import { useTranslation } from 'react-i18next'
import { MainContentArea } from '@/components/layout/MainContentArea'
import { ContentNavigator } from '@/components/content/ContentNavigator'
import { useContentBundle } from '@/hooks/useContentBundle'
import { useAppStore } from '@/store/appStore'
import { trackPageView } from '@/services/appInsights'
import { AdditionalReadingCategory } from '@/types/api'

export function CrosswalksPage() {
  const { t } = useTranslation()
  const { data: bundle, isLoading } = useContentBundle()
  const { isManualOffline, isTrulyOffline } = useAppStore()

  if (isLoading) {
    return (
      <MainContentArea>
        <div className="loading-state">{t('pages.loading')}</div>
      </MainContentArea>
    )
  }

  if (!bundle) {
    return (
      <MainContentArea>
        <div className="error-state">{t('content.unavailable')}</div>
      </MainContentArea>
    )
  }

  const crosswalkItems = bundle.additionalReading
    .filter((r) => r.category === AdditionalReadingCategory.Crosswalks)
    .sort((a, b) => a.sortOrder - b.sortOrder)

  const handleItemSelect = (item: { id: number; displayName: string }) => {
    const offlineMode = isManualOffline && isTrulyOffline ? 'both' : isManualOffline ? 'manual' : isTrulyOffline ? 'network' : 'none'
    trackPageView('Crosswalks', `/crosswalks/${item.id}`, {
      additionalReadingId: String(item.id),
      additionalReadingName: item.displayName,
      offlineMode,
    })
  }

  return (
    <MainContentArea>
      <ContentNavigator
        items={crosswalkItems}
        bundle={bundle}
        emptyMessage={t('pages.noCrosswalkContent')}
        navLabel={t('pages.crosswalkNav')}
        onItemSelect={handleItemSelect}
      />
    </MainContentArea>
  )
}
